import axios from 'axios';

export const setAuthToken = token => {
    if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    else {
        delete axios.defaults.headers.common["Authorization"];
    }
}

// Initialize auth token from localStorage on app start
const initializeAuthToken = () => {
    const token = localStorage.getItem('authToken');
    if (token) {
        setAuthToken(token);
    }
}

// Call this when the app starts
initializeAuthToken();
